import appsettings from "@/store/app-settings";
import { axiosGet, axiosPost } from "@/store/api/axiosUtils.js";
import * as userData from "@/auth/localStorageUtils.js";

const search = (params) => {
  return axiosGet(appsettings.ocpbComplaintAPIUrl + "api/Role/Search", params);
};

const getMenu = (id) => {
  const params = {
    id,
  };

  return axiosGet(
    appsettings.ocpbComplaintAPIUrl + "api/Role/GetRoleMenu",
    params
  );
};

const getById = (id) => {
  const params = {
    id,
  };

  return axiosGet(appsettings.ocpbComplaintAPIUrl + "api/Role/GetById", params);
};

const updateItem = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl +
      "api/Role/Update?userId=" +
      userData.userId(),
    params
  );
};

const updateItemActive = (id, isActive) => {
  const params = {
    id,
    isActive,
    userId: userData.userId(),
  };

  return axiosPost(
    appsettings.ocpbComplaintAPIUrl + "api/Role/UpdateActive",
    params
  );
};

const deleteItem = (id) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl +
      "api/Role/Delete?id=" +
      id +
      "&userId=" +
      userData.userId()
  );
};

const updateRoleMenu = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl +
      "api/Role/UpdateRoleMenu?userId=" +
      userData.userId(),
    params
  );
};

const getRoleUserAddList = (params) => {
  return axiosGet(
    appsettings.ocpbComplaintAPIUrl + "api/Role/GetRoleUserAddList",
    params
  );
};

const getRoleUserList = (params) => {
  return axiosGet(
    appsettings.ocpbComplaintAPIUrl + "api/Role/GetRoleUserList",
    params
  );
};

const addRoleUserList = (params) => {
  params.userId = userData.userId()
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl + "api/Role/AddRoleUserList",
    params
  );
};
const removeRoleUserList = (params) => {
  params.userId = userData.userId()
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl + "api/Role/RemoveRoleUserList",
    params
  );
};

const updateRoleUserProvince = (roleId, userId, area, province, district, subDistrict) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl +
      "api/Role/UpdateRoleUserProvince?roleId=" +
      roleId +
      "&userId=" +
      userId +
      "&province=" +
      province +
      "&area=" +
      area +
      "&district=" +
      district +
      "&subDistrict=" +
      subDistrict
  );
};

export {
  search,
  getMenu,
  getById,
  updateItem,
  updateItemActive,
  deleteItem,
  updateRoleMenu,
  getRoleUserAddList,
  getRoleUserList,
  addRoleUserList,
  removeRoleUserList,
  updateRoleUserProvince,
};
